import React from 'react';
import { Container, InnerContainer } from './styles';
import Pagination from '../../content/pagination';
import Zoom from '../../content/zoom';
import { LangButton } from '../../content/lang';
import { useMediaQuery } from '@react-hook/media-query';

export const Footer = () => {
    const isMobile = useMediaQuery('only screen and (max-width: 768px)');
    return (
        <Container>
            <InnerContainer>
                <Pagination />
                {isMobile ? null : <>
                    <LangButton />
                    <Zoom />
                </>}
            </InnerContainer>
        </Container>
    )
}

export default Footer;